import React from 'react';
import { motion } from 'framer-motion';
import { dossierSections } from '../data/dossierSections';
interface FilePageProps {
  id: string;
  number: string;
  label: string;
  tone?: 'gold' | 'danger';
  children: React.ReactNode;
}
export function FilePage({
  id,
  number,
  label,
  tone = 'gold',
  children
}: FilePageProps) {
  const accent = tone === 'danger' ? 'text-signal-pink' : 'text-gold';
  const border = tone === 'danger' ? 'border-signal-pink/35' : 'border-gold/30';
  return <section id={id} aria-labelledby={`${id}-label`} className="relative scroll-mt-[88px] border-b border-white/[0.07] px-5 py-10 sm:px-10 sm:py-14 lg:scroll-mt-20 lg:px-14 lg:py-20" data-id="element-181" data-mp="3q8p5mhz30if1">
      <motion.header initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.6
    }} transition={{
      duration: 0.5
    }} className="mb-6 flex items-center gap-3 sm:mb-9 sm:gap-4" data-id="element-182" data-mp="3txc0mqihlu7">
        <span className={`flex h-8 w-8 flex-shrink-0 items-center justify-center rounded border ${border} font-mono text-[12px] font-bold ${accent}`} data-id="element-183" data-mp="37ge8z5v0tgpd">
          {number}
        </span>
        <h2 id={`${id}-label`} className={`font-mono text-[10px] font-bold uppercase tracking-[0.22em] sm:text-[11px] ${accent}`} data-id="element-184" data-mp="deerpelc0mtn">
          {label}
        </h2>
        <span aria-hidden="true" className="h-px flex-1 bg-[repeating-linear-gradient(90deg,rgba(255,255,255,0.16)_0_6px,transparent_6px_12px)]" data-id="element-185" data-mp="9b0a4jhqvye3" />
        <span className="hidden font-mono text-[9.5px] uppercase tracking-[0.16em] text-white/25 sm:block" data-id="element-186" data-mp="3viq4pygwtj8j">
          Folio {number}/{dossierSections.length.toString().padStart(2, '0')}
        </span>
      </motion.header>

      {children}
    </section>;
}